import React, { Component } from 'react'
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'

class InitReferrer extends Component {
    constructor(props) {
        super(props)
    }
    componentDidMount(props){
        if(this.props.match.params.refCode) {
            window.localStorage.setItem('refCode', this.props.match.params.refCode);
        }
        this.props.history.push('/get-started');
    }
    render() {
        return(<div></div>)
    }
}
export default connect( ({Dashboard, User}) => ({Dashboard, User}) ) (InitReferrer)


// WEBPACK FOOTER //
// ./src/components/steps/InitReferrer.js